"use strict";
var ApiResponseContainer = (function () {
    function ApiResponseContainer() {
    }
    return ApiResponseContainer;
}());
exports.ApiResponseContainer = ApiResponseContainer;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-response-container.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-response-container.model.js